// @module NXTurn.ShoppingExtensions.Carousel
define('C3.ShoppingExtensions.GroupAddToCart.View'
,	[
	'c3_shoppingextensions_groupaddtocart.tpl'
	, 'item_relations_row.tpl'
	, 'item_relations_cell.tpl'
	,'ItemRelations.Related.Collection'
	,'ProductLine.Sku.View'
	,'ProductDetails.Quantity.View'
	,'ProductDetails.ImageGallery.View'
	, 'C3.ShoppingExtensions.GroupAddToCart.RelatedItem.View'
//	,'NXTurn.AAMedical.PLPQuickViewExtension.RelatedItem.View'
	,'Backbone.CollectionView'
	,'AjaxRequestsKiller'
	,'LiveOrder.Model'
    , 'Tracker'
	,'Profile.Model'
	,'Product.Model'
	, 'Utils'
	,   'SCView'
	,   'GoogleTagManager'
    ]
, function (
	 c3_shoppingextensions_groupaddtocart_tpl
	, item_relations_row_tpl
	, item_relations_cell_tpl
	//, nxturn_shoppingextensions_groupaddtocart_relateditem_tpl
	, ItemRelationsRelatedCollection
	, ProductLineSkuView
	, ProductDetailsQuantityView
	, ProductDetailsImageGalleryView
	, C3ShoppingExtensionsGroupAddToCartRelatedItemView
	//,PLPQuickViewExtensionRelatedItemView
	, BackboneCollectionView
	, AjaxRequestsKiller
	, LiveOrderModel
    , Tracker
	, ProfileModel
	, ProductModel
	, Utils 	
	, SCViewModule
	,  GoogleTagManager
)
{
    'use strict';

    var SCView = SCViewModule.SCView;

    function GroupAddToCartView (options) {
        SCView.call(this, options);

        //console.log(options)
        //console.log(options.model)

        this.template = c3_shoppingextensions_groupaddtocart_tpl;
        this.options = options;
        this.application = options.application;
        this.model=options.model;

        this.addQuantity = function addQuantity(e){

        	$(".last-bottom").css('display','block');

			const $element = self.$(e.target);
	        const quantity_input = $element.parent().find('input');
	        const button_minus = $element.parent().find('.cart-item-summary-quantity-remove-cust');
	       	const find_title_ele = $element.closest('.e2');

	        //console.log(quantity_input)
	        quantity_input.show();
	        button_minus.show();

	        find_title_ele.addClass('newly-added-css');
	        
	        const old_value = quantity_input.val();
			let new_val = parseFloat(old_value) == 0 ? 1 : parseFloat(old_value)+1; 
			quantity_input.val(new_val);

			let popupQuanity=jQuery('.popup-quantity').val();
			if(popupQuanity == "" || popupQuanity == undefined || popupQuanity == "undefined")
				popupQuanity = 0
			jQuery('.popup-quantity').val(parseFloat(popupQuanity)+1);

			var final_popup_qty = parseFloat(popupQuanity)+1;

			//console.log(final_popup_qty)

			/*Total qty display within the lightbox category*/
			
			var findDesiredEle =  $element.parent('.this-is-right')
			,   findDesiredEleParent = findDesiredEle.parent('.thumbnail-qty-fields')
			,   uniqueIdentifier = findDesiredEleParent.attr('data-unique-identifier');
			
			var findUnique = $('div[id="in-modal-'+uniqueIdentifier+'"]').siblings('.home-summary-expander-head');
			var findUniqueChildren = findUnique.find('.lightbox-category-quantity')
			findUniqueChildren.css('display','inline');

			var catergoryQuanity=jQuery('.category-quantity-'+uniqueIdentifier+'').val();
			if(catergoryQuanity == "" || catergoryQuanity == undefined || catergoryQuanity == "undefined")
				catergoryQuanity = 0
			jQuery('.category-quantity-'+uniqueIdentifier+'').val(parseFloat(catergoryQuanity)+1);

			var final_category_qty = parseFloat(catergoryQuanity)+1;
			var adjustQtyToEle = findUniqueChildren.find('.quantity-number').text(final_category_qty)
			
			/*Total qty display within the lightbox category*/
			
			

			if(final_popup_qty == 1){
				$(".quick-view-add-to-cart .bold-count").html(''+final_popup_qty+' ITEM');
				$(".quick-view-add-to-quote .bold-count").html(''+final_popup_qty+' ITEM');
			}
			else{
				$(".quick-view-add-to-cart .bold-count").html(''+final_popup_qty+' ITEMS');
				$(".quick-view-add-to-quote .bold-count").html(''+final_popup_qty+' ITEMS');
			}
        }

        this.removeQuantity = function removeQuantity(e)
        {
        	const $element = self.$(e.target);
	        const quantity_input = $element.parent().find('input');
	       	const find_title_ele = $element.closest('.e2');
	        const old_value = quantity_input.val();
	        if(old_value==1 )
	        {
	        	find_title_ele.removeClass('newly-added-css');
	        	let new_val = parseFloat(old_value) - 1;
				quantity_input.val(new_val);
	        	$element.attr("style","display:none !important;");
	        	quantity_input.hide();
	        }
	        else if(old_value>1 ){
	        	let new_val = parseFloat(old_value) - 1;
	        	quantity_input.val(new_val);
	        }
	        let popupQuanity=jQuery('.popup-quantity').val();
			
			if(popupQuanity > 1)
				popupQuanity = parseFloat(popupQuanity)-1
			else
				popupQuanity = ""

			jQuery('.popup-quantity').val(popupQuanity);

			//console.log(popupQuanity)

			/*Total qty display within the lightbox category*/
			
			var findDesiredEle =  $element.parent('.this-is-right')
			,   findDesiredEleParent = findDesiredEle.parent('.thumbnail-qty-fields')
			,   uniqueIdentifier = findDesiredEleParent.attr('data-unique-identifier');
			
			var findUnique = $('div[id="in-modal-'+uniqueIdentifier+'"]').siblings('.home-summary-expander-head');
			var findUniqueChildren = findUnique.find('.lightbox-category-quantity')
			findUniqueChildren.css('display','inline');

			var catergoryQuanity=jQuery('.category-quantity-'+uniqueIdentifier+'').val();
			if(catergoryQuanity == "" || catergoryQuanity == undefined || catergoryQuanity == "undefined")
				catergoryQuanity = 0
			jQuery('.category-quantity-'+uniqueIdentifier+'').val(parseFloat(catergoryQuanity)-1);

			var final_category_qty = parseFloat(catergoryQuanity)-1;
			var adjustQtyToEle = findUniqueChildren.find('.quantity-number').text(final_category_qty)
			if(final_category_qty == '' || final_category_qty == null){
				findUniqueChildren.css('display','none');
			}
			
			/*Total qty display within the lightbox category*/
			

			if(popupQuanity == 1){
			$(".quick-view-add-to-cart").html('ADD <b class="bold-count">'+popupQuanity+'</b> ITEM TO BAG');
			$(".quick-view-add-to-quote").html('ADD <b class="bold-count">'+popupQuanity+'</b> ITEM TO BAG');	
			}
			else{
				$(".quick-view-add-to-cart").html('ADD <b class="bold-count">'+popupQuanity+'</b> ITEMS TO BAG');
				$(".quick-view-add-to-quote").html('ADD <b class="bold-count">'+popupQuanity+'</b> ITEMS TO BAG');	
			}
				
			if(popupQuanity == '' || popupQuanity == null){
				$(".last-bottom").css('display','none');
			}	
        }

        this.addToCart = function addToCart(e){
        	var self=this;
			var lines=[];
			var cart = this.application.getComponent('Cart');
			var isQuoteItem=jQuery('.is-quote-item').val();

			var liveOrder = LiveOrderModel.getInstance();
			
			if(isQuoteItem)
			{
				jQuery('.quick-view-add-to-cart').prop('disabled', true);
				SC.loadingIndicatorShow();
				var quoteItemId=jQuery('.quote-item-id').val();
				var quoteItemDescription=jQuery('.quote-item-description').val();
				var fileIds=jQuery('.file-ids').val();
				var fileNames=jQuery('.file-names').val();
				var quantity=jQuery( ".item-quickview-quantity-value" ).val()
				if(quoteItemDescription!="" /*&& fileIds!=""*/)
				{
					var lineData={
						quantity: parseFloat(quantity),
						options:[{
						"value":{"label": fileNames,"internalid": fileNames},
						"cartOptionId": "custcol_aamedical_quote_imagenames",
						"label": "AAMedical Quote Item Images"
						},
						{
						"value":{"label": fileIds,"internalid": fileIds},
						"cartOptionId": "custcol_aamedical_quote_item_images",
						"label": "AAMedical Quote Item Images"
						},
						{
						"value":{"label": quoteItemDescription,"internalid": quoteItemDescription},
						"cartOptionId": "custcol_aamedical_quote_item_desc",
						"label": "AA Medical SCA Quote Item Desc"
						}],
						item: {
							internalid: parseFloat(quoteItemId)
						}
					};
				 	lines.push(lineData);
					cart.addLines({lines: lines}).then(function()
					{
						jQuery('.quick-view-add-to-cart').prop('disabled', false);
						SC.loadingIndicatorHide();
						jQuery('.global-views-modal-content-header-close').trigger('click',true)
						if(!Utils.isPhoneDevice())
						jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");

					    //Snippet for GTM DataLayer
                        var cartLinesDL = liveOrder.get('lines')
                        ,   cartLinesModelsDL = cartLinesDL.models
                        ,   finalCartArray = []

                        _.each(cartLinesModelsDL, function(line) {
                            var lineItem = line.get('item')
                            ,   lineItemName = lineItem.get('displayname')
                            ,   lineItemSKU = lineItem.get('itemid')
                            ,   lineQty = line.get('quantity')
                            ,   lineRate = line.get('rate')
							,   lineGroup = lineItem.get('custitemproduct_category')
							,   lineCategory =  lineItem.get('custitem168')

							finalCartArray.push({
							    'item': lineItemSKU,
							    'quantity':  lineQty,
							    'price': lineRate,
							    'unique_id': lineItemSKU,
							    'ProductGroup' : lineGroup,
							    'ProductCategory' : lineCategory

							})
                        });

                        const gtm = GoogleTagManager;
                        const eventName = 'cartInfo';
                         const eventData = {
                            event: eventName,
                            cartUpdates: finalCartArray
                         }
                         Tracker.trigger(eventName, eventData);
                         gtm.pushData(eventData);
                         //console.log(gtm.win)

                         //console.log(finalCartArray)
                        /*var _etmc = [];
						_etmc.push(['trackCart', {
						    'cart': finalCartArray
						}]);*/
                         //setTimeout(function() { 
                            var appendParentElement = $('.append-abandoned-cart-items')
                            appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
                         //}, 1000); 
					});
				}
				else{
					alert('Please Add Item Description');
					jQuery('.quick-view-add-to-cart').prop('disabled', false);		
				}
			}
			else
			{
				var flag= false;
				jQuery( ".item-quickview-quantity-value" ).each(function( index )
				{
				  	var quantity = jQuery( this ).val();
				  	var internalID=jQuery( this ).attr("data-id");
				  	if(quantity>0)
				  	{
					  	flag=true;
					  	var lineData={quantity: parseFloat(quantity),
					  				item: {internalid: parseFloat(internalID)}
					  	};
					  	lines.push(lineData);
				 	}
				 });
			
				if(flag)
				{
					jQuery('.quick-view-add-to-cart').prop('disabled', true);
					SC.loadingIndicatorShow();
					cart.addLines({lines: lines}).then(function() {
						jQuery('.quick-view-add-to-cart').prop('disabled', false);
						SC.loadingIndicatorHide();
						jQuery('.global-views-modal-content-header-close').trigger('click',true)
						if(!Utils.isPhoneDevice())
						jQuery('.header-mini-cart-menu-cart-link').dropdown("toggle");

						//Snippet for GTM DataLayer
                        var cartLinesDL = liveOrder.get('lines')
                        ,   cartLinesModelsDL = cartLinesDL.models
                        ,   finalCartArray = []

                        _.each(cartLinesModelsDL, function(line) {
                            var lineItem = line.get('item')
                            ,   lineItemName = lineItem.get('displayname')
                            ,   lineItemSKU = lineItem.get('itemid')
                            ,   lineQty = line.get('quantity')
                            ,   lineRate = line.get('rate')
							,   lineGroup = lineItem.get('custitemproduct_category')
							,   lineCategory =  lineItem.get('custitem168')

							finalCartArray.push({
							    'item': lineItemSKU,
							    'quantity':  lineQty,
							    'price': lineRate,
							    'unique_id': lineItemSKU,
							    'ProductGroup' : lineGroup,
							    'ProductCategory' : lineCategory

							})
                        });

                        const gtm = GoogleTagManager;
                        const eventName = 'cartInfo';
                         const eventData = {
                            event: eventName,
                            cartUpdates: finalCartArray
                         }
                         Tracker.trigger(eventName, eventData);
                         gtm.pushData(eventData);
                         //console.log(gtm.win)

                         console.log(finalCartArray)
                        /*var _etmc = [];
						_etmc.push(['trackCart', {
						    'cart': finalCartArray
						}]);*/
                         //setTimeout(function() { 
                            var appendParentElement = $('.append-abandoned-cart-items')
                            appendParentElement.html('<script>var _etmc = _etmc || [];_etmc.debug=true;_etmc.push(["setOrgId", "534010071"]);_etmc.push(["trackCart", {"cart": '+JSON.stringify(finalCartArray)+'}]);</script>') 
                         //}, 1000); 
					});	
				}
				else{
					//jQuery('.quick-view-add-to-cart').prop('disabled', false);
					alert("Please select Item");
				}
			}
        }
    }

    GroupAddToCartView.prototype = Object.create(SCView.prototype);
    GroupAddToCartView.prototype.constructor = GroupAddToCartView;

    GroupAddToCartView.prototype.getChildViews = function (){
    	return {
    		'Product.Sku': function() {
                return new ProductLineSkuView({
                    model: this.model
                });
            },
            'Product.ImageGallery': function() {
                return new ProductDetailsImageGalleryView({
                    model: this.model,
                    application: this.options.application
                });
            },
            'Related.Items.Extension': function()
            {
            	var relateditems_detail=this.model.get('item').get('relateditems_detail');    
            	var subCategoriesList = _.uniq(_.pluck(relateditems_detail || [], 'custitem158')); 
            	var sorted_relateditems=_.sortBy(relateditems_detail, 'custitem158'); 	
            	var dummyList=[];
            	var newList=[];
            	_.each(sorted_relateditems,function(item,index)
            	{
            	 	var itemSubCategory=item.custitem158;

            	 	var qtyAvailableInv = item.custitem_qty_available_inv
            	 	,   enableOutOfStock = item.custitem_celigo_shopify_enable_out_sto
            	 	,   qtyAvailableKit = item.custitem_qty_available_kit
            	 	//,   noQuantityAvailable = false;

            	 	if(qtyAvailableInv == undefined)
					qtyAvailableInv = 0;

					if(qtyAvailableKit == undefined)
					qtyAvailableKit = 0;

            	 	if(qtyAvailableInv <= 0 && enableOutOfStock == false)
					{
						//noQuantityAvailable = true;
						item.noQuantityAvailable = true; 
					}

					if(qtyAvailableKit <= 0 && enableOutOfStock == false)
					{
						item.noQuantityAvailable = true; 
					}
				            	 	
            	 	if(itemSubCategory=="" || itemSubCategory==null){
            	 		item.custitem158="Other";
            	 		itemSubCategory="Other"
            	 	}
            	 	
            	 	if(!_.contains(dummyList, itemSubCategory))
            	 	{
            	 		dummyList.push(itemSubCategory);
            	 		item.showSubCategory=true;
            	 		item.subitems=[];
            	 		newList.push(item)
            	 		item.uniqueNo=Math.floor(1000000 + Math.random() * 9000000);
							    
            	 	}
            	 	else{
            	 		var newListitem=_.filter(newList,function(item)
            	 		{
            	 			return item.custitem158==itemSubCategory
            	 		});
            	 		if(item.itemimages_detail){
            	 			if(item.itemimages_detail.urls)
            	 				item.image=item.itemimages_detail.urls[0].url
            	 		}
            	 		//debugger
            	 		newListitem[0].subitems.push(item);
            	 		item.showSubCategory=false;	
            	 	}
            	 });

            	return new BackboneCollectionView({
            		collection: newList,
		            viewsPerRow: Infinity,
		            cellTemplate: item_relations_cell_tpl,
		            rowTemplate: item_relations_row_tpl,
		            childView: C3ShoppingExtensionsGroupAddToCartRelatedItemView
		            //template: nxturn_shoppingextensions_groupaddtocart_relateditem_tpl
            	});
       		 }
    	}
    }

    GroupAddToCartView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }

    GroupAddToCartView.prototype.getEvents = function (){
    	return {
    		'click [data-action="addtocart"]': 'addToCart',
			'click [data-action="plus"]': 'addQuantity',
	   		'click [data-action="minus"]': 'removeQuantity'
    	}
    }

    GroupAddToCartView.prototype.getContext = function () {
    	 var item_model = this.model.get('item');

        return {
        		model: this.model,
                sku : this.model.get('item').get('itemid'),
                hideItemQuantity:!this.model.get('item').get('custitem157'),
                internalid: this.model.get('item').get('internalid'),
                // @property {String} pageHeader
                pageHeader: this.model.get('item').get('_pageHeader'),
                // @property {String} itemUrl
                itemUrl: item_model.get('_url') + this.model.getQuery(),
                // @property {Boolean} isItemProperlyConfigured
                isItemProperlyConfigured: item_model.isProperlyConfigured(),
                // @property {Boolean} isPriceEnabled
                isPriceEnabled: !ProfileModel.getInstance().hidePrices(),
                isPhoneDevice : Utils.isPhoneDevice(),
                mostPopularFlag : item_model.get('custitem160'),
                itemURL: this.model.get('item').get('_url'),
                itemId: this.model.get('item').get('_id')
        }
    }

    return GroupAddToCartView;

});
